import styled from '@emotion/styled'
import { colors } from 'styles/variables'

export const StyledCustomIconWrapper = styled.div`
  & svg {
    &:hover path {
      fill: ${colors.greens.green7};
    }
    path {
      fill: ${(p) => (p.$isActive ? colors.greens.green7 : '#fff')};
    }
  }
`
